import { Box } from '@mui/material';
import { MUIStyledCommonProps } from '@mui/system';
import { Theme } from '@emotion/react';
import { ICountry } from '../../../models/ICountry';
import IMTitle from '../../../components/typography/IMText';
import IMText from '../../../components/typography/IMTitle';



type Props = {
	highlighted?: boolean,
	country: {
		country_name: string,
		country_name_ru: string,
		best_tags?: string[],
		total_score: number,
	};
	number: number;
} & MUIStyledCommonProps<Theme>;

const CountryScoreRect = ({ number, country, highlighted, sx, ...props }: Props) => {
	return (
		country && <Box
			sx={{
				backgroundColor: '#F6F6F6',
				border: !highlighted ? '1px solid #0000000D' : '1px solid rgb(248, 176, 9)',
				borderRadius: '12px',
				display: 'flex',
				padding: '4px 12px 4px 4px',
				alignItems: 'center',
				overflow: 'hidden',
				...sx,
			}}
			{...props}
		>
			<Box
				sx={{
					display: 'flex',
					border: '1px solid #0000000D',
					borderRadius: '8px',
					paddingRight: '14px',
					paddingLeft: '14px',
					backgroundColor: '#FFFFFF',
					height: '70px',
					alignItems: 'center',
					margin: '0px 12px 0px 0px',
					width: '64px',
					flexShrink: 0,
				}}
			>
				<IMTitle weight="500" size="20px" color="#212B36" props={{
					width: '26px',
					minWidth: '26px',
				}}>{number}.</IMTitle>
				<Box
					component={'img'}
					src={`/assets/flags/${country?.country_name}.webp?x=1`}
					alt=""
					sx={{
						width: '48px',
						height: '48px',
						flexShrink: 0,
					}}
				></Box>
			</Box>
			<Box sx={{
				flex: 1
			}}>
				<IMText weight="500" size="14px" color="#212B36" props={{
					margin: '0px 0 8px 0'
				}}>{country?.country_name_ru}</IMText>
				<Box sx={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: '4px'
				}}>
					{/* {(country?.tags || []).map(tag => (
						<CountryTag key={tag.criteria_id}>
							{tag.tag}
						</CountryTag>
					))} */}
					{(country?.best_tags || []).map(tag => (
						<CountryTag key={tag}>
							{tag}
						</CountryTag>
					))}
				</Box>
			</Box>
			<Box sx={{
				width: '44px',
				flexShrink: 0,
				height: '33px',
				backgroundColor: '#39B54A1A',
				border: '1px solid #39B54A26',
				borderRadius: '8px',
				justifyContent: 'center',
				alignItems: 'center',
				display: 'flex',
			}}>
				<IMText weight="500" size="14px" color="#39B54A">{Math.floor(country?.total_score || 0)}</IMText>
			</Box>
		</Box>
	);
};


function CountryTag({ children }: { children: React.ReactNode }) {
	return (
		<Box
			sx={{
				borderWidth: '1px',
				borderRadius: '30px',
				padding: '5px 10px',
				background: '#FFFFFF',
				border: '1px solid #0000000D',
				display: 'inline-block',
			}}
		>
			<IMText weight="500" size="10px" color="#212B36" props={{
				textWrapMode: 'nowrap'
			}}>
				{children}
			</IMText>
		</Box>
	);
}

export default CountryScoreRect;
